module.exports = __webpack_public_path__ + "4b0318dcf01112e1663fedbabdb58f79.png";